<template>
  <div id="app">

    <el-container>
      <el-header style="" class="header_box">

        <!-- <el-row :gutter="24">
          <el-col :span="19" :md="19">
            <div class="grid-content"
                 style="font-size: 20px;  display: flex; padding-left: 20px; color: #323232; text-decoration: none">
              <div @click="goHome" v-if="chain.avatar" style="padding-top: 10px">
                <img class="avatar_box" :src="chain.avatar" style=""/>
              </div>
              <div @click="goHome" style=" font-size: 17px; margin-left: 20px; font-weight: bold">{{ chain.name }}</div>

              <div v-if="menus.length > 1" style="display: flex; margin-left: 60px;overflow: hidden; max-height: 50px">
                <div @click="changeMenu(item.link)" v-for="(item,index) in menus" :key="index"
                     style="margin-right: 40px; font-size: 17px;  cursor: pointer; "
                     :style="{'color': select_menu === item.link ? '#326ffe' : 'black', 'border-bottom': select_menu === item.link ? '2px solid #326ffe' : '', 'font-weight': select_menu === item.link ? 'bold' : ''}">
                  {{ item.name }}
                </div>
              </div>

              <div style="margin-left: 50px; font-size: 16px; display: flex" v-if="platform == 1">
                <div>
                  算力: {{ ai_asset.token }}
                </div>
                <el-button @click="recharge" icon="el-icon-coin" size="small"
                           style="height: 30px; margin-top: 15px; margin-left: 20px">去充值
                </el-button>
                <el-button @click="contact" icon="el-icon-chat-dot-round" size="small"
                           style="height: 30px; margin-top: 15px; margin-left: 20px">联系客服
                </el-button>
              </div>

            </div>
          </el-col>
          <el-col :span="4" :md="4" style="text-align: left; display: flex; max-height: 50px;">
            <img :src="user.avatar" style="width: 35px; height: 35px; border-radius: 50%; margin-top: 13px"
                 @click="updateUser"/>
            <div class="grid-content" style="font-size: 14px; margin-left: 10px;  color: #6c6c6c; " @click="updateUser">
              {{ user.nick }}
            </div>
            <div v-if="login" @click="logout" class="grid-content point"
                 style="font-size: 14px;  margin-left: 20px;  color: #6c6c6c; ">退出
            </div>
            <div id="login" v-if="!login" @click="checkLogin" class="grid-content"
                 style="font-size: 14px;  margin-left: 60px;  color: #6c6c6c; ">登陆
            </div>
          </el-col>
        </el-row> -->

        <div class="flexMainXYcenter justify-between">
          <div class="left_box flexMainXYcenter">
            <div class="flexMainXYcenter point" @click="goHome">
              <img  v-if="chain.avatar" class="avatar_box" :src="chain.avatar" style=""/>
              <div class="company_name" style="">{{ chain.name }}</div>
            </div>
            <div v-if="menus.length > 1" class="" style="display: flex; margin-left: 60px;overflow: hidden; max-height: 50px">
              <div @click="changeMenu(item.link)" v-for="(item,index) in menus" :key="index"
                     style="margin-right: 40px; font-size: 17px;  cursor: pointer; "
                     :style="{'color': select_menu === item.link ? '#326ffe' : 'black', 'border-bottom': select_menu === item.link ? '2px solid #326ffe' : '', 'font-weight': select_menu === item.link ? 'bold' : ''}">
                  {{ item.name }}
              </div>
            </div>

            <div class="flexMainXYcenter computing_power"  style="" v-if="platform == 1">
              <div>
                算力: {{ ai_asset.token }}
              </div>
              <el-button @click="customerHandle" icon="el-icon-coin" size="small" class="handle_btn" style="">
                去充值
              </el-button>
              <el-button @click="customerHandle" icon="el-icon-chat-dot-round" size="small" class="handle_btn" style="">
                联系客服
              </el-button>
            </div>
          </div>
          <div class="right_box flexMainXYcenter">
            <div class="flexMainXYcenter point" @click="updateUser">
              <img :src="user.avatar" class="user_avatar" style="" />
              <div class="grid-content user_nick" style="">
                {{ user.nick }}
              </div>
            </div>
            <div v-if="login" @click="logout" class="grid-content point user_handle_btn" style="">
              退出
            </div>
            <div id="login" v-if="!login" @click="checkLogin" class="grid-content point user_handle_btn" style="">
              登陆
            </div>
          </div>
        </div>
      </el-header>
      <el-container class="main_box">


        <!--        <div-->
        <!--          style="margin-top: 60px;  padding-top: 30px;  width: 250px; background: #ffffff; position: fixed; z-index: 299; top:0;left:0;bottom: 0; box-sizing: border-box; overflow-y: auto;">-->
        <!--          <div v-for="(group,index) in menus" :key="index" style="margin-bottom: 20px;margin-left: 20px;">-->
        <!--            <div style="margin-bottom: 5px">-->
        <!--              <i :class="group.icon"></i>-->
        <!--              <span style="font-size: 17px;font-weight: bold">{{ group.name }}</span>-->
        <!--            </div>-->

        <!--            <div v-for="(subGroup,index) in group.children" :key="index" style="padding-top: 10px">-->
        <!--              <span v-if="subGroup.children.length > 0 && group.children.length > 0" style="margin-bottom: 3px; margin-top: 10px; margin-left: 25px; color: #a39c9c;  padding: 4px; border-radius: 3px; background:#ededed;">{{ subGroup.name }}</span>-->
        <!--              <span v-if="subGroup.children.length === 0" style="margin-bottom: 3px; margin-top: 10px; margin-left: 25px; color: #a39c9c;  padding: 4px; border-radius: 3px; ">{{ subGroup.name }}</span>-->

        <!--              <div style="margin-bottom: 15px; margin-left: 25px; margin-top: 10px">-->
        <!--                <el-row>-->
        <!--                  <el-col :span = 12 v-for="(menu,index) in subGroup.children" :key="index" style="margin-top: 10px">-->
        <!--                    <span class="box" @click="clickMenu(subGroup,menu)"-->
        <!--                          v-if="subGroup.active == openName1 && menu.active==activeName1"-->
        <!--                          style="font-size: 15px; ">{{ menu.name }}</span>-->
        <!--                    <span class="box" @click="clickMenu(subGroup,menu)" v-else style="font-size: 15px;cursor: pointer;">{{ menu.name }}</span>-->
        <!--                  </el-col>-->
        <!--                </el-row>-->
        <!--              </div>-->
        <!--            </div>-->
        <!--            &lt;!&ndash;<div style="width: 100%;height: 1px; background: #efefef"></div>&ndash;&gt;-->
        <!--          </div>-->

        <!--        </div>-->


        <!--        <div style="display: flex; margin-top: 60px;  position: fixed;z-index: 299; top:0;left:0;bottom: 0;width: 240px;">-->
        <!--    <div class="leftNavMenu1">-->

        <!--<div style="background-color:#fbfbfb; min-height:20px; display: block;  border-right: 1px solid #f1f1f1; ">-->
        <!--&lt;!&ndash;<a href="/"><img :src="company.logo" width="30px" height="30px" style="border-radius:30px; margin-left:35px; margin-top:18px;" /></a>&ndash;&gt;-->
        <!--</div>-->

        <!--    <div style="flex:1; background-color:#fbfbfb;  border-right: 1px solid #f1f1f1;">-->
        <!--      <div class="site-logo">-->
        <!--    </div>-->

        <!--    </div>-->


        <!--    </div>-->

        <!--  <Sider v-if="menus.length>0" hide-trigger :style="{background: '#fff'}" style="overflow-y: auto; max-width: 150px;width:150px;min-width:150px;flex: 0 0 150px;">-->
        <!--    <div style="background-color:#f9f9f9; height:20px"></div>-->
        <!--    <Menu ref="sideMenu" width="auto" updateOpened :active-name="activeName" :open-names="openNodeNames"-->
        <!--          @on-select="routerPush"  v-if="menus" >-->
        <!--      <div v-for="items in menus" >-->
        <!--        <MenuItem v-if="items.children.length ==1" style="padding-left:25px;" :name="items.children[0].active">-->
        <!--          {{items.name}}1111-->
        <!--        </MenuItem>-->

        <!--        <Submenu :name="items.active" v-else  :key="items.name">-->
        <!--          <template slot="title" style="padding-left:0px;">-->
        <!--            {{items.name}}-->
        <!--          </template>-->
        <!--          <MenuItem style="padding-left: 45px;padding-right:5px;" v-if="items.children.length>1" v-for="item in items.children"  :name="item.active" :key="item.name">-->
        <!--            {{item.name}}-->
        <!--          </MenuItem>-->
        <!--        </Submenu>-->
        <!--      </div>-->
        <!--    </Menu>-->

        <!--  </Sider>-->

        <!--  </div>-->


        <div style="" class="aside_box">
          <el-menu v-if="select_menus.length > 0 && select_menus[0].children.length > 0"
                   :default-active="active"
                   :default-openeds="openIds"
                   :collapse="isCollapse"
                   :unique-opened="true"
                   style="height: 100%; max-width: 170px; min-width: 170px; margin-bottom: 100px; margin-top: -60px; overflow-y: auto; "
                   @open="handleOpen"
                   @close="handleClose"
                   @select="clickMenu">
            <el-submenu :index="groupIndex+''" v-for="(groupItem,groupIndex) in select_menus" :key="groupIndex">
              <!--              <template slot="title">-->
              <!--                <i :class="groupItem.icon"></i>-->
              <!--                <span style="font-size: 16px">{{ groupItem.name }}</span>-->
              <!--              </template>-->
              <el-menu-item-group v-for="(item,subGroupIndex) in groupItem.children" :key="subGroupIndex">
                <template v-if="item.children.length > 0" slot="title">
                  <span style="margin-left: 40px; font-size: 12px">
                    {{ item.name }}
                  </span>
                </template>
                <template v-if="item.children.length === 0" slot="title">
                  <el-menu-item :index="groupIndex+':'+subGroupIndex"><i v-if="item.icon" :class="item.icon"></i>{{ item.name }}</el-menu-item>
                </template>
                <template slot="title">
                  <el-menu-item @select="clickMenu" :index="groupIndex+':'+subGroupIndex+':'+index" v-for="(item,index)  in item.children" :key="index">
                    {{ item.name }}
                  </el-menu-item>
                </template>
              </el-menu-item-group>
            </el-submenu>

            <div v-if="select_menu === 'home' && platform == 2" @click="customMenuConfig"
                 style="margin-left: 40px; color: darkgray; margin-top: 30px; font-size: 14px; cursor: pointer">设置快捷操作
            </div>
          </el-menu>
        </div>


        <el-main class="main_msg_box" style="">
          <div style="border-radius: 5px; background: white; padding: 20px">
            <el-button  v-if="showBackButton" icon="el-icon-back" @click="back" style=" margin-bottom: 10px">
              返回
            </el-button>
            <router-view @checkLogin="checkLogin"/>
          </div>
        </el-main>
      </el-container>
    </el-container>

    <Login ref="login" @loginSuccess="loginSuccess"></Login>
    <custom-menu ref="customMenu"></custom-menu>
    <customerService ref="customer"/>
  </div>
</template>

<script>

import Login from './LoginModal';
import CustomMenu from '../pages/account/custom_menu'
import customerService from './customerService.vue'

export default {
  name: 'App',
  data() {
    return {
      openIds: ['0'],
      isCollapse: false,
      chains: [],
      user: {},
      chain: {name: ''},
      menus: [],
      select_menus: [],
      select_menu: 'home',
      active: '0:0',
      login: false,
      select_chain_id: 0,
      platform: 0,
      ai_asset: {},

      historyLength: 0,
      showBackButton: false
    }
  },
  created: function () {
    this.platform = this.$platform;
    this.historyLength = window.history.length;
  },
  mounted: function () {

    const token = localStorage.getItem("token");
    this.login = token != null && token != "";

    if (this.login) {
      this.getUserInfo();
      //this.getChainOptions();
      this.getMenus()
      this.getChainInfo()
      if (this.platform == 1) {
        this.getUserAiAsset();
      }
    } else {
      this.checkLogin()
    }

  },
  watch: {
    $route(to, from) {
      //this.historyLength = window.history.length;
      console.log(to)
      this.showBackButton = to.query.return == 1;
    }
  },
  components: {
    Login, CustomMenu,customerService
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    recharge() {
      this.$router.push('/app/wallet')
    },
    contact() {

    },
    customerHandle(){
      this.$refs.customer.init();
    },
    back() {
      this.$router.go(-1);
    },

    goHome() {
      this.$router.push('/app/index')
      this.changeMenu('home')
    },

    clickMenu(index, indexPath) {
      //console.log(index)
      const indexs = index.split(":");
      let link = "";
      if (indexs.length === 2) {
        link = this.select_menus[indexs[0]].children[indexs[1]].link
      } else if (indexs.length === 3) {
        link = this.select_menus[indexs[0]].children[indexs[1]].children[indexs[2]].link
      }
      console.log(link)
      // if (link === '/app_image/index') {
      //   window.open(this.$router.resolve({path: link}).href, '_blank');
      // } else {
      this.$router.push({path: link});
      //}
      this.active = index;
    },

    changeMenu(link, no_push) {
      localStorage.setItem('current_menu_link',link)
      let select_menus = []
      this.menus.forEach(item => {
        if (item.link === link) {
          select_menus.push(item)
        }
      })

      this.active = "0:0"
      this.select_menus = select_menus;
      console.log('获取后的菜单',this.select_menus)
      this.select_menu = link

      if (!no_push)
        this.$router.push({path: select_menus[0].children[0].link});

    },

    customMenuConfig() {
      this.$refs.customMenu.init()
    },

    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    getUserInfo: function () {
      let that = this;
      this.$get(
          {
            context: that,
            path: '/user/info/',
            params: {},
            success: function (data) {
              that.user = data.user;
              console.log(data)
            }
          }
      )
    },

    getUserAiAsset: function () {
      let that = this;
      this.$get(
          {
            context: that,
            path: '/user/ai/asset/',
            params: {},
            success: function (data) {
              that.ai_asset = data;
              console.log(data)
            }
          }
      )
    },

    getChainInfo: function () {
      let that = this;
      this.$get(
          {
            context: that,
            path: '/chain/info/',
            params: {},
            success: function (data) {
              that.chain = data.chain;
            }
          }
      )
    },
    getMenus: function () {
      let t = this;
      this.$get(
          {
            context: t,
            path: '/function/menu/pc/',
            params: {},
            success: function (data) {
              console.log('menus',data.menus);
              t.menus = data.menus;
              let link = localStorage.getItem('current_menu_link');
              if (t.$route.path === '/app/index'){
                link = null
              }
              console.log('菜单',t.menus)
              t.changeMenu(link ? link:'home',link != null)
            }
          }
      )
    },

    updateUser() {
      this.$router.push({path: '/app/account_update'});
    },

    logout: function () {
      localStorage.setItem("token", "");
      localStorage.setItem("userId", 0);
      try {
        if (window.pywebview) {
          window.pywebview.api.save_user_data(0, '').then(function (response) {
          });
        }
      } catch (e) {
        console.log(e)
      }
      this.login = false;
      this.$message({
        message: '退出成功',
      })

      //this.$router.push({path: '/app/index'});
      // window.location.href = '/'
      this.$router.push({path: '/login'})
    },

    loginSuccess: function () {
      this.login = true;
      // window.location.href = "/"
      location.reload();
    },
    checkLogin: function () {
      let token = localStorage.getItem("token");
      if (!token) {
        this.$refs.login.init()
        return false;
      } else {
        return true;
      }
    }
  }
}
</script>

<style lang="less">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin: 0
}

.el-header, .el-footer {
  /*background-image: linear-gradient(135deg, #9a48ee 10%, #5961F9 100%) !important;*/
  background: #f9f9fc;
  color: #cee5fb;
  text-align: left;
  line-height: 60px;
  border-bottom: 1px solid #efefef;
}

.el-aside {
  background-color: transparent;
  color: #333;
  text-align: center;
  line-height: 200px;
}

.el-main {
  background-color: transparent;
}

/**el-menu默认样式 */
.el-menu {
  border-right: 0 !important; /*去掉element menu的右侧边框 */
  /*background-image: linear-gradient(135deg, #EE9AE5 10%, #5961F9 100%) !important;*/
  -ms-overflow-style: none; /* IE 和 Edge */
  scrollbar-width: none; /* Firefox */
}

.el-menu::-webkit-scrollbar {
  display: none; /* 隐藏滚动条 */
}

.el-menu .el-menu-item {
  border-radius: 5px !important;
  padding-left: 0px !important;
  font-size: 15px;
}

.el-menu .el-menu-item.is-active {
  font-weight: 500 !important;
  font-size: 15px !important;
  /*color: #7d69f9;*/
  color: #326ffe;
  background: white;
}

.el-submenu .el-submenu__title .el-submenu__icon-arrow {
  display: none;
}

.el-submenu .el-submenu__title i.el-icon-arrow-down {
  display: none;
}

.el-submenu .el-submenu__title {
  padding-right: 20px; /* 根据需要调整右侧内边距 */
}

/*body > .el-container {*/
/*margin-bottom: 40px;*/
/*}*/

/*.el-container:nth-child(5) .el-aside,*/
/*.el-container:nth-child(6) .el-aside {*/
/*line-height: 260px;*/
/*}*/

/*.el-container:nth-child(7) .el-aside {*/
/*line-height: 320px;*/
/*}*/

/*项目定义*/
.bottom_space {
  margin-bottom: 30px;
}

a {
  text-decoraction: none;
}

.router-link-active {
  text-decoration: none;
}



.header_box{
  z-index: 1000;
  position: fixed;
  left: 0;
  right: 0;
  top:0;
  color: #323232; 
  .avatar_box{
    width: auto; 
    height: 40px; 
    margin-top: 0px; 
    border-radius: 2px;
    object-fit: contain;
  }

  .company_name{
    font-size: 17px; 
    margin-left: 20px; 
    font-weight: bold;
  }
  .computing_power{
    margin-left: 50px; 
    font-size: 16px;
    .handle_btn{
      height: 30px;
      margin-left: 20px
    }
  }
  .user_avatar{
    width: 35px; 
    height: 35px; 
    border-radius: 50%;
  }
  .user_nick{
    font-size: 14px; 
    margin-left: 10px;  
    color: #6c6c6c;
  }
  .user_handle_btn{
    font-size: 14px;  
    margin-left: 20px;  
    color: #6c6c6c; 
  }
}

.main_box{
  margin-top: 60px;
}

.aside_box{
  border-right: 0px solid #e8e8e8; 
  height: calc(100vh - 60px);
  position: fixed;
  left: 0;
  top: 60px;
  z-index: 999;
}

.main_msg_box{
  background: #f6f6f6;
  padding: 10px;
  margin-left: 170px;
}

</style>
